import { FederationLicense, FederationLicenseItem, OrganizationUser, User } from '@vote4dance/judging-schema';
import { Organization } from '@vote4dance/judging-schema';
import { FederationId, OrganizationId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";
import { FederationEnforcementLogItem, FederationItem } from './federations';

export type OrganizationItem = Organization
& Pick<OrganizationUser, 'organization_permissions' | 'organization_approved'>

export const OrganizationSource = new StreamSource<OrganizationItem[]>("/organizations");
export const UserOrganizationSource = new StreamSource<OrganizationItem[]>("/user-organizations");

export type OrganizationUserItem = OrganizationUser
& Pick<User, 'user_email' | 'user_firstname' | 'user_lastname'>

type OrganizationUserItemCompanion = {
    getFullName(user: OrganizationUserItem): string
}

export const OrganizationUserItem: OrganizationUserItemCompanion = {
    getFullName(user: OrganizationUserItem): string {
        return user.user_firstname + ' ' + user.user_lastname;
    }
}

export function OrganizationItemSource(organization_id: OrganizationId) {
    return new StreamSource<OrganizationItem>(`/organizations/${organization_id}`);
}

export function OrganizationUserSource(organization_id: OrganizationId) {
    return new StreamSource<OrganizationUserItem[]>(`/organizations/${organization_id}/users`);
}

export function OrganizationFederationSource(organization_id: OrganizationId) {
    return new StreamSource<FederationItem[]>(`/organizations/${organization_id}/federations`);
}

export function OrganizationFederationLicenseSource(organization_id: OrganizationId, federation_id: FederationId) {
    return new StreamSource<FederationLicense[]>(`/organizations/${organization_id}/federations/${federation_id}/licenses`);
}

export function OrganizationFederationLicenseItemSource(organization_id: OrganizationId, federation_id: FederationId) {
    return new StreamSource<FederationLicenseItem[]>(`/organizations/${organization_id}/federations/${federation_id}/license-items`);
}

export function OrganizationFederationEnforcementLogSource(organization_id: OrganizationId, federation_id: FederationId) {
    return new StreamSource<FederationEnforcementLogItem[]>(`/organizations/${organization_id}/federations/${federation_id}/enforcement-log`);
}
